import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=cfb88c04&scoped=true&"
import script from "./ChangePassword.vue?vue&type=script&lang=js&"
export * from "./ChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./ChangePassword.vue?vue&type=style&index=0&id=cfb88c04&prod&lang=scss&scoped=true&"
import style1 from "./ChangePassword.vue?vue&type=style&index=1&id=cfb88c04&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfb88c04",
  null
  
)

export default component.exports